import { useLocation, useNavigate } from "react-router-dom";
import React, { useState, useRef, useEffect } from "react";
import { Link } from "react-router-dom";
import { toast } from "react-toastify";
import { getAuthCookie } from "../../utils/authCookies";
// import "react-toastify/dist/ReactToastify.css";
import $ from "jquery";
import "datatables.net";
import "datatables.net-responsive";
import { Product, Office, TaxGroup } from "types";

type OfficeInventoryObj = {
  product_id: string;
  office: Office;
  product: Product;
  created_by: {
    id: string;
    name: string;
  }
};

const RealtorInventory = () => {
  const [taxGroups, setTaxGroups] = useState<TaxGroup[]>([]);
  const [error, setError] = useState<string>("");
  const [loading, setLoading] = useState(true);
  const [deleting, setDeleting] = useState<string | null>(null); // Track deletion in progress
  const token = getAuthCookie("sessionToken");
  const userId = getAuthCookie("userId");
  const [toastShown, setToastShown] = useState(false);
  const location = useLocation();
  const [officeProducts, setOfficeProducts] = useState<OfficeInventoryObj[]>([]);
  const [products, setProducts] = useState<Product[]>([]);
  const navigate = useNavigate();

  useEffect(() => {
    const fetchProducts = async () => {
      try {
        const response = await fetch(
        //   `${process.env.REACT_APP_API_URL}/office/${userId}/inventory/products`,
        `${process.env.REACT_APP_API_URL}/user/office-inventory`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );

        if (!response.ok) {
          throw new Error(`Error: ${response.statusText}`);
        }

        const data = await response.json();
        // console.log("Fetched data:", data);
        // setTempObject(data);
        // Ensure the response contains the expected structure
        if (data && Array.isArray(data)) {
          setOfficeProducts(data);
          // setProducts(data.products);
        } else {
          console.error("Unexpected API response structure:", data);
          setOfficeProducts([]);
          // setProducts(data.products);
        }
      } catch (err) {
        console.error("Error fetching products:", err);
        setError(err instanceof Error ? err.message : "Unknown error");
      } finally {
        setLoading(false);
      }
    };

    fetchProducts();
  }, [token, userId]);

  useEffect(() => {
    const fetchTaxGroups = async () => {
      try {
        const response = await fetch(
          `${process.env.REACT_APP_API_URL}/tax-groups`,
          {
            method: "GET",
            headers: {
              Authorization: `Bearer ${token}`,
              "Content-Type": "application/json",
            },
          }
        );
        const data = await response.json();
        setTaxGroups(data);
      } catch (err) {
        setError(
          err instanceof Error ? err.message : "An unknown error occurred"
        );
      } finally {
        setLoading(false);
      }
    };

    fetchTaxGroups();
  }, [token]);

  const handleDelete = async (productId: string) => {
    setDeleting(productId); // Set the product being deleted
  
    try {
      const response = await fetch(
        `${process.env.REACT_APP_API_URL}/office/${userId}/inventory/products/${productId}`,
        {
          method: "DELETE",
          headers: {
            Authorization: `Bearer ${token}`,
            "Content-Type": "application/json",
          },
        }
      );
  
      if (!response.ok) {
        throw new Error("Failed to delete the product.");
      }
  
      toast.success("Product deleted successfully!");
      // Update the state by removing the deleted product
      setOfficeProducts((prev) => prev?.filter((product) => product.product_id !== productId));
      setDeleting(null); // Clear the deleting state
      navigate(0);
    } catch (err) {
      toast.error("Failed to delete the product.");
      setError(
        err instanceof Error
          ? err.message
          : "An unknown error occurred while deleting."
      );
      setDeleting(null); // Clear the deleting state
    }
  };

  useEffect(() => {
    if(officeProducts!=null && officeProducts?.length > 0) {
      const table = $("#transactions").DataTable({
        responsive: false,
        destroy: true,
        lengthChange: false,
        ordering: false,
      });

      return () => {
        table.destroy();
      };
    }
  }, [officeProducts]);

  if (loading) {
    return <div>Loading...</div>;
  }
  
  return (
    <div className="content">
      <div className="card">
        <div className="card-body">
          <h2>Inventory </h2>
          <div className="text-end">
            <a
              href="/realtor/addProduct"
              className="btn btn-primary float-right"
            >
              Add Product
            </a>
          </div>
          <div className="row justify-content-center">
            <div className="col-md-12 col-lg-12 col-xl-12">
              <div className="card mt-4 card-bg-fill">
                <div className="card-body p-4">
                  <div className="table-container">
                    <table
                      id="transactions"
                      className="table table-bordered dt-responsive nowrap table-striped align-middle w-100"
                    >
                      <thead>
                        <tr>
                          {/* <th>
                            <input type="checkbox" />
                          </th> */}
                          <th>S.No.</th>
                          <th>Image</th>
                          <th>Product Name</th>
                          <th>Category</th>
                          <th>Qty</th>
                          <th>Status</th>
                          <th>Installer Status</th>
                          <th>Condition</th>
                          <th>Dimensions</th>
                          <th>Weight</th>
                          <th>Linked Installer</th>
                          <th>Actions</th>
                        </tr>
                      </thead>
                      <tbody>
                        {officeProducts != null &&
                          officeProducts?.map((officeproduct, index) => (
                            <tr key={officeproduct.product_id}>
                              {/* <td><input type="checkbox" /></td> */}
                              <td>{index + 1}</td>
                              <td className="text-center">
                                {officeproduct.product.image?.url ? (
                                  <img
                                    src={`${process.env.REACT_APP_BASE_URL}${officeproduct.product.image.url}`}
                                    alt="Product"
                                    height={50}
                                  />
                                ) : (
                                  "No Image"
                                )}
                              </td>
                              <td>{officeproduct.product.name}</td>
                              <td>{officeproduct.product.category}</td>
                              <td>
                                {officeproduct?.product.variants?.[0]?.inventory?.[0]
                                  ?.on_hand ?? 0}
                              </td>
                              <td>{officeproduct.product.status}</td>
                              <td>{officeproduct.product.linked_mode}</td>
                              <td>{officeproduct.product.item_condition}</td>
                              <td>
                                {officeproduct.product.package_dimensions?.length} x{" "}
                                {officeproduct.product.package_dimensions?.height} x{" "}
                                {officeproduct.product.package_dimensions?.width}
                              </td>
                              <td>{officeproduct.product.package_dimensions?.weight}</td>
                              <td>
                                {officeproduct.product.linked_installer || "None"}
                              </td>
                              <td>
                                <Link
                                  to={`/realtor/editProduct/${officeproduct.product_id}`}
                                  className="btn btn-warning me-2"
                                >
                                  Edit
                                </Link>
                                <button
                                  onClick={() =>
                                    window.confirm("Delete this product?") &&
                                    handleDelete(officeproduct.product_id)
                                  }
                                  className="btn btn-danger"
                                >
                                  Delete
                                </button>
                              </td>
                            </tr>
                          ))}
                      </tbody>
                    </table>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default RealtorInventory;
